<div class="merchant-container">
  <img src="{{this.image}}" (error)="setDefaultPlaceholder()" class="merchant-image" alt="merchant">
  <div class="merchant-desc-container">
    <div class="merchant-name"><p>{{ merchant.name }}</p></div>
    <div class="merchant-desc"><p>{{ merchant.brief }}</p></div>
    <div class="merchant-details" (click)="viewMerchant()">
      <p i18n="@@viewProfile">View profile</p>
    </div>
  </div>
</div>
